import { CheckBusinessEntity } from '@zenbusiness/application-commons-business-entity';
import { LoadingZone } from '@zenbusiness/application-commons-loading';
import PageLoading from '@zenbusiness/zui/PageLoading';
import { Outlet } from 'react-router-dom';

export default function BusinessEntityGate({ children }) {
  return (
    <LoadingZone
      bubble
      loadId="BusinessEntityGate"
      timeout={5000}
    >
      <LoadingZone.Prepare loadId="BusinessEntity Ready" />
      <CheckBusinessEntity loadingElement={<PageLoading />}>
        <LoadingZone.Status
          loadId="BusinessEntity Ready"
          status={LoadingZone.DONE}
        />
        {children || <Outlet />}
      </CheckBusinessEntity>
    </LoadingZone>
  );
}
